<template lang="pug">
.mt-4
  h2 Organisatie gegevens

  v-expansion-panel.elevation-0(v-model='expanded', expand)
    v-expansion-panel-content
      span(slot='header'): h3 Algemeen
      v-card.pa-4
        v-form(autocomplete='on')
          v-layout.flex-column-phone
            text-field(
              label='Bedrijfsnaam',
              v-model='dataGeneral.companyName',
              required,
              name='companyName',
              :error-messages='companyNameValidationErrors',
              @change='$v.dataGeneral.companyName.$touch()',
              @blur='$v.dataGeneral.companyName.$touch()'
              )

          v-layout.flex-column-phone
            text-field.mr-4(
              label='K.v.K. Nummer',
              v-model='dataGeneral.kvkNumber',
              required,
              name='kvk',
              :error-messages='kvkNumberValidationErrors',
              @change='$v.dataGeneral.kvkNumber.$touch()',
              @blur='$v.dataGeneral.kvkNumber.$touch()'
              )

            text-field(
              label='BTW-Nummer',
              v-model='dataGeneral.vatNumber',
              required,
              name='vat',
              :error-messages='vatNumberValidationErrors',
              @change='$v.dataGeneral.vatNumber.$touch()',
              @blur='$v.dataGeneral.vatNumber.$touch()'
              )

    v-expansion-panel-content
      span(slot='header'): h3 Adresgegevens
      v-card.pa-4
        v-form(autocomplete='on')
          v-layout.flex-column-phone
            text-field.mr-4(
              label='Straat',
              v-model='dataAddress.streetName',
              required,
              name='streetName'
              :error-messages='addressStreetNameValidationErrors',
              @change='$v.dataAddress.streetName.$touch()',
              @blur='$v.dataAddress.streetName.$touch()'
              )

            text-field.mr-4.small(
              label='Nummer',
              v-model='dataAddress.streetNumber',
              required,
              name='streetNumber',
              :error-messages='addressStreetNumberValidationErrors',
              @change='$v.dataAddress.streetNumber.$touch()',
              @blur='$v.dataAddress.streetNumber.$touch()'
              )

            text-field.small(
              label='Toev.',
              v-model='dataAddress.streetNumberAddition'
              )

          v-layout.flex-column-phone
            text-field.mr-4(
              label='Postcode',
              v-model='dataAddress.postalCode',
              required,
              mask='#### AA',
              name='postalCode',
              :error-messages='addressPostalCodeValidationErrors',
              @change='$v.dataAddress.postalCode.$touch()',
              @blur='$v.dataAddress.postalCode.$touch()'
              )

            text-field(
              label='Plaats',
              v-model='dataAddress.city',
              required,
              name='city',
              :error-messages='addressCityValidationErrors',
              @change='$v.dataAddress.city.$touch()',
              @blur='$v.dataAddress.city.$touch()'
              )

            v-layout(column)
              label: b Land
              v-autocomplete(
                :items='countryItems',
                item-value='short_name',
                item-text='name',
                solo,
                name='country',
                v-model='dataAddress.country',
                required
                :error-messages='addressCountryValidationErrors',
                )

          v-switch(
            v-model='dataAddress.differentBillingAddress',
            color='primary',
            label='Ander factuuradres gebruiken'
            )

    v-expansion-panel-content(v-if='dataAddress.differentBillingAddress')
      span(slot='header'): h3 Factuuradres
      v-card.pa-4
        v-form(autocomplete='on')
          v-layout.flex-column-phone
            text-field.mr-4(
              label='Straat',
              v-model='dataBillingAddress.streetName',
              required,
              name='streetName',
              :error-messages='billingStreetNameValidationErrors',
              @change='$v.dataBillingAddress.streetName.$touch()',
              @blur='$v.dataBillingAddress.streetName.$touch()'
              )

            text-field.mr-4.small(
              label='Nummer',
              v-model='dataBillingAddress.streetNumber',
              required,
              name='streetNumber',
              :error-messages='billingStreetNumberValidationErrors',
              @change='$v.dataBillingAddress.streetNumber.$touch()',
              @blur='$v.dataBillingAddress.streetNumber.$touch()'
              )

            text-field.small(
              label='Toev.',
              v-model='dataBillingAddress.streetNumberAddition'
              )

          v-layout.flex-column-phone
            text-field.mr-4(
              label='Postcode',
              v-model='dataBillingAddress.postalCode',
              required,
              name='postalCode',
              mask='#### AA',
              :error-messages='billingPostalCodeValidationErrors',
              @change='$v.dataBillingAddress.postalCode.$touch()',
              @blur='$v.dataBillingAddress.postalCode.$touch()'
              )

            text-field(
              label='Plaats',
              v-model='dataBillingAddress.city',
              required,
              name='city',
              :error-messages='billingCityValidationErrors',
              @change='$v.dataBillingAddress.city.$touch()',
              @blur='$v.dataBillingAddress.city.$touch()'
              )

          v-layout.flex-column-phone
            v-layout(column)
              label: b Land
              v-autocomplete(
                :items='countryItems',
                item-value='short_name',
                item-text='name',
                solo,
                name='country',
                v-model='dataBillingAddress.country',
                required
                :error-messages='billingCountryValidationErrors',
                )

    v-expansion-panel-content
      span(slot='header')
        v-layout.flex-column-phone(align-center)
          h3 Contactpersoon

      v-card.pa-4
        span Hier worden de facturen en financiële informatie naar toegezonden

        v-form(autocomplete='on')
          v-layout.pt-4(column)
            label: b Aanhef*
            v-radio-group(
              v-model='dataAdministrationContact.sex'
              :error-messages='administrationSexValidationErrors'
              )
              v-layout
                v-radio.mb-0(value='M', label='De heer', color='primary')
                v-radio.mb-0(value='F', label='Mevrouw', color='primary')

          v-layout.flex-column-phone
            text-field.mr-4(
              label='Voorletters',
              mask='A.A.A.A.A.',
              v-model='dataAdministrationContact.initials',
              required,
              name='initials',
              :error-messages='administrationInitialsValidationErrors',
              @change='$v.dataAdministrationContact.initials.$touch()',
              @blur='$v.dataAdministrationContact.initials.$touch()'
              )

            text-field(
              label='Achternaam',
              v-model='dataAdministrationContact.lastName',
              required,
              name='lastname',
              :error-messages='administrationLastNameValidationErrors',
              @change='$v.dataAdministrationContact.lastName.$touch()',
              @blur='$v.dataAdministrationContact.lastName.$touch()'
              )

          v-layout.flex-column-phone
            text-field.mr-4(
              label='E-mailadres',
              v-model='dataAdministrationContact.email',
              required,
              name='email',
              :error-messages='administrationEmailValidationErrors',
              @change='$v.dataAdministrationContact.email.$touch()',
              @blur='$v.dataAdministrationContact.email.$touch()'
              )

            text-field(
              label='Telefoon',
              v-model='dataAdministrationContact.phone',
              required,
              mask='+## # ## ### ###',
              name='phone',
              :error-messages='administrationPhoneValidationErrors',
              @change='$v.dataAdministrationContact.phone.$touch()',
              @blur='$v.dataAdministrationContact.phone.$touch()'
              )

    v-expansion-panel-content
      span(slot='header')
        v-layout.flex-column-phone(align-center)
          h3 Supportmedewerker

      v-card.pa-4
        span Onderstaande is bedoeld zodat klanten contact kunnen opnemen voor vragen. Dit wordt gebruikt in alle communicatie richting de klant.

        //- TODO fix this super weird bug that makes autofilled text unselectable
        v-form.mt-4(autocomplete='off')
          v-layout.flex-column-phone
            text-field(
              label='Telefoon',
              required,
              v-model='dataSupportContact.numberPhone',
              mask='+## # ## ### ###',
              :error-messages='supportNumberPhoneValidationErrors',
              @change='$v.dataSupportContact.numberPhone.$touch()',
              @blur='$v.dataSupportContact.numberPhone.$touch()'
              )

            text-field(
              label='WhatsApp nummer',
              v-model='dataSupportContact.numberWhatsapp',
              mask='+## # ## ### ###',
              :error-messages='supportNumberWhatsappValidationErrors',
              @change='$v.dataSupportContact.numberWhatsapp.$touch()',
              @blur='$v.dataSupportContact.numberWhatsapp.$touch()'
              )

            text-field(
              label='E-mailadres',
              v-model='dataSupportContact.email',
              autocomplete='support-email-address',
              required,
              :error-messages='supportEmailValidationErrors',
              @change='$v.dataSupportContact.email.$touch()',
              @blur='$v.dataSupportContact.email.$touch()'
              )

    v-expansion-panel-content
      span(slot='header')
        v-layout.flex-column-phone(align-center)
          h3 Standaard huisstijl

      v-card.pa-4
        span Deze huisstijl wordt toegepast op alle websiteprofielen. Per websiteprofiel kan dit overschreven worden indien gewenst.

        FormStyle(
          v-if='showFormStyle',
          :primaryColor.sync='defaultFormStyle.primaryColor',
          :backgroundColor.sync='defaultFormStyle.backgroundColor',
          :logo.sync='defaultFormStyle.logoUrl',
          :backgroundImage.sync='defaultFormStyle.backgroundImageUrl',
          )

  //- v-layout(justify-end) //- TODO $v.$touch supprt in Save
    v-btn.validates(color='primary', :class='{ "v-btn--disabled": $v.$invalid }', @mouseover='$v.$touch', @click='save', :loading='loading') Opslaan
</template>

<script>
import countries from 'dealerfinanceservices-shared/src/assets/countries.json'
import { required, minLength, maxLength, requiredIf, email, numeric } from 'vuelidate/lib/validators'
import { fullPhoneRegex } from 'dealerfinanceservices-shared/src/helpers/regex'

// TODO add "are you sure" msg if changed not saved when changing tab or page

export default {
  components: {
    FormStyle: require('@/components/FormStyle').default
  },

  data () {
    return {
      expanded: [true, true, true, true, true], // TODO always expand BillingAddress when checkbox on
      loading: false,
      showFormStyle: false, // Need to load picture-input when expansion panels are done animating or it cant calculate height yet

      dataGeneral: null,
      dataAddress: {
        country: 'NL'
      },
      dataBillingAddress: null,
      dataAdministrationContact: null,
      dataSupportContact: null,
      defaultFormStyle: null
    }
  },

  computed: {
    countryItems () {
      return countries
    },

    companyNameValidationErrors () {
      const errors = []
      if (!this.$v.dataGeneral.companyName.$dirty) return errors
      !this.$v.dataGeneral.companyName.required && errors.push('Dit veld is verplicht')
      return errors
    },

    kvkNumberValidationErrors () {
      const errors = []
      if (!this.$v.dataGeneral.kvkNumber.$dirty) return errors
      !this.$v.dataGeneral.kvkNumber.required && errors.push('Dit veld is verplicht')
      !this.$v.dataGeneral.kvkNumber.numeric && errors.push('Dit is geen geldig KvK nummer')
      !this.$v.dataGeneral.kvkNumber.minLength && errors.push('Dit is geen geldig KvK nummer')
      !this.$v.dataGeneral.kvkNumber.maxLength && errors.push('Dit is geen geldig KvK nummer')
      return errors
    },

    vatNumberValidationErrors () {
      const errors = []
      if (!this.$v.dataGeneral.vatNumber.$dirty) return errors
      !this.$v.dataGeneral.vatNumber.required && errors.push('Dit veld is verplicht')
      return errors
    },

    addressStreetNameValidationErrors () {
      const errors = []
      if (!this.$v.dataAddress.streetName.$dirty) return errors
      !this.$v.dataAddress.streetName.required && errors.push('Dit veld is verplicht')
      return errors
    },

    addressStreetNumberValidationErrors () {
      const errors = []
      if (!this.$v.dataAddress.streetNumber.$dirty) return errors
      !this.$v.dataAddress.streetNumber.required && errors.push('Dit veld is verplicht')
      return errors
    },

    addressPostalCodeValidationErrors () {
      const errors = []
      if (!this.$v.dataAddress.postalCode.$dirty) return errors
      !this.$v.dataAddress.postalCode.required && errors.push('Dit veld is verplicht')
      !this.$v.dataAddress.postalCode.regex && errors.push('Voer de postcode in dit formaat in: 1234AB')
      return errors
    },

    addressCityValidationErrors () {
      const errors = []
      if (!this.$v.dataAddress.city.$dirty) return errors
      !this.$v.dataAddress.city.required && errors.push('Dit veld is verplicht')
      return errors
    },

    addressCountryValidationErrors () {
      const errors = []
      if (!this.$v.dataAddress.country.$dirty) return errors
      !this.$v.dataAddress.country.required && errors.push('Dit veld is verplicht')
      return errors
    },

    billingStreetNameValidationErrors () {
      const errors = []
      if (!this.$v.dataBillingAddress.streetName.$dirty) return errors
      !this.$v.dataBillingAddress.streetName.required && errors.push('Dit veld is verplicht')
      return errors
    },

    billingStreetNumberValidationErrors () {
      const errors = []
      if (!this.$v.dataBillingAddress.streetNumber.$dirty) return errors
      !this.$v.dataBillingAddress.streetNumber.required && errors.push('Dit veld is verplicht')
      return errors
    },

    billingPostalCodeValidationErrors () {
      const errors = []
      if (!this.$v.dataBillingAddress.postalCode.$dirty) return errors
      !this.$v.dataBillingAddress.postalCode.required && errors.push('Dit veld is verplicht')
      if (this.dataAddress.differentBillingAddress) {
        !this.$v.dataBillingAddress.postalCode.regex && errors.push('Voer de postcode in dit formaat in: 1234AB')
      }
      return errors
    },

    billingCityValidationErrors () {
      const errors = []
      if (!this.$v.dataBillingAddress.city.$dirty) return errors
      !this.$v.dataBillingAddress.city.required && errors.push('Dit veld is verplicht')
      return errors
    },

    billingCountryValidationErrors () {
      const errors = []
      if (!this.$v.dataBillingAddress.country.$dirty) return errors
      !this.$v.dataBillingAddress.country.required && errors.push('Dit veld is verplicht')
      return errors
    },

    administrationSexValidationErrors () {
      const errors = []
      if (!this.$v.dataAdministrationContact.sex.$dirty) return errors
      !this.$v.dataAdministrationContact.sex.required && errors.push('Dit veld is verplicht')
      return errors
    },

    administrationInitialsValidationErrors () {
      const errors = []
      if (!this.$v.dataAdministrationContact.initials.$dirty) return errors
      !this.$v.dataAdministrationContact.initials.required && errors.push('Dit veld is verplicht')
      return errors
    },

    administrationLastNameValidationErrors () {
      const errors = []
      if (!this.$v.dataAdministrationContact.lastName.$dirty) return errors
      !this.$v.dataAdministrationContact.lastName.required && errors.push('Dit veld is verplicht')
      return errors
    },

    administrationEmailValidationErrors () {
      const errors = []
      if (!this.$v.dataAdministrationContact.email.$dirty) return errors
      !this.$v.dataAdministrationContact.email.required && errors.push('Dit veld is verplicht')
      !this.$v.dataAdministrationContact.email.email && errors.push('Dit is geen geldig email adres')
      return errors
    },

    administrationPhoneValidationErrors () {
      const errors = []
      if (!this.$v.dataAdministrationContact.phone.$dirty) return errors
      !this.$v.dataAdministrationContact.phone.required && errors.push('Dit veld is verplicht')
      !this.$v.dataAdministrationContact.phone.regex && errors.push('Gebruik het volgende formaat: +31 6 12 123 123')
      return errors
    },

    supportNumberPhoneValidationErrors () {
      const errors = []
      if (!this.$v.dataSupportContact.numberPhone.$dirty) return errors
      !this.$v.dataSupportContact.numberPhone.required && errors.push('Dit veld is verplicht')
      !this.$v.dataSupportContact.numberPhone.regex && errors.push('Gebruik het volgende formaat: +31 6 12 123 123')
      return errors
    },

    supportNumberWhatsappValidationErrors () {
      const errors = []
      if (!this.$v.dataSupportContact.numberWhatsapp.$dirty) return errors
      !this.$v.dataSupportContact.numberWhatsapp.regex && errors.push('Gebruik het volgende formaat: +31 6 12 123 123')
      return errors
    },

    supportEmailValidationErrors () {
      const errors = []
      if (!this.$v.dataSupportContact.email.$dirty) return errors
      !this.$v.dataSupportContact.email.required && errors.push('Dit veld is verplicht')
      !this.$v.dataSupportContact.email.email && errors.push('Dit is geen geldig email adres')
      return errors
    }
  },

  methods: {
    async save () {
      if (this.$v.$invalid) return

      this.loading = true

      try {
        const variables = {
          orgId: this.$store.state.organization.currentOrgId,
          dataGeneral: this.dataGeneral,
          dataAddress: this.dataAddress,
          dataAdministrationContact: this.dataAdministrationContact,
          dataSupportContact: this.dataSupportContact,
          defaultFormStyle: this.defaultFormStyle
        }

        if (this.dataAddress.differentBillingAddress) {
          variables.dataBillingAddress = this.dataBillingAddress
        }

        if (this.defaultFormStyle.logoUrl) {
          if (this.defaultFormStyle.logoUrl instanceof File) {
            const logoUrl = await this.$store.dispatch('files/upload', {
              type: 'form_logo',
              data: this.defaultFormStyle.logoUrl
            })

            this.defaultFormStyle.logoUrl = logoUrl
          }
        }

        if (this.defaultFormStyle.backgroundImageUrl) {
          if (this.defaultFormStyle.backgroundImageUrl instanceof File) {
            const backgroundImageUrl = await this.$store.dispatch('files/upload', {
              type: 'form_background',
              data: this.defaultFormStyle.backgroundImageUrl
            })

            this.defaultFormStyle.backgroundImageUrl = backgroundImageUrl
          }
        }

        await this.$store.dispatch('graphqlMutation', {
          name: 'setOrganizationSettings',
          variables,
          deleteCacheQueries: ['getOrganization']
        })

        this.$root.$snackbar.show('Organisatie gegevens zijn aangepast')

        if (this.$store.getters['organization/isFirstUse']) {
          location.reload() // Can be done without reload but reload brings us to a guaranteed correct state
        }
      } catch (error) {
        this.$root.$snackbar.show('Organisatie gegevens zijn NIET aangepast')
      }

      this.loading = false
    }
  },

  validations: {
    dataGeneral: {
      companyName: {
        required
      },

      kvkNumber: {
        required,
        numeric,
        minLength: minLength(8),
        maxLength: maxLength(8)
      },

      vatNumber: {
        required
      }
    },

    dataAddress: {
      streetName: {
        required
      },

      streetNumber: {
        required
      },

      streetNumberAddition: {},

      postalCode: {
        required,
        regex: (v) => /^\d{4}\w{2}$/i.test(v)
      },

      city: {
        required
      },

      country: {
        required
      }
    },

    dataBillingAddress: {
      streetName: {
        required: requiredIf(function (dataBillingAddress) {
          return this.dataAddress.differentBillingAddress && !dataBillingAddress.streetName
        })
      },

      streetNumber: {
        required: requiredIf(function (dataBillingAddress) {
          return this.dataAddress.differentBillingAddress && !dataBillingAddress.streetNumber
        })
      },

      streetNumberAddition: {},

      postalCode: {
        required: requiredIf(function (dataBillingAddress) {
          return this.dataAddress.differentBillingAddress && !dataBillingAddress.postalCode
        }),
        regex: requiredIf(function (dataBillingAddress) {
          return /^\d{4}\w{2}$/i.test(dataBillingAddress.postalCode)
        })
      },

      city: {
        required: requiredIf(function (dataBillingAddress) {
          return this.dataAddress.differentBillingAddress && !dataBillingAddress.city
        })
      },

      country: {
        required: requiredIf(function (dataBillingAddress) {
          return this.dataAddress.differentBillingAddress && !dataBillingAddress.country
        })
      }
    },

    dataAdministrationContact: {
      sex: {
        required
      },

      initials: {
        required
      },

      lastName: {
        required
      },

      email: {
        required,
        email
      },

      phone: {
        required,
        regex: (v) => fullPhoneRegex.test(v)
      }
    },

    dataSupportContact: {
      numberPhone: {
        required,
        regex: (v) => fullPhoneRegex.test(v)
      },

      numberWhatsapp: {
        regex: (v) => {
          if (!v) return true

          return fullPhoneRegex.test(v)
        }
      },

      email: {
        required,
        email
      }
    }
  },

  created () {
    this.dataGeneral = this.$store.state.organization.current.dataGeneral || {}
    this.dataAddress = this.$store.state.organization.current.dataAddress && Object.keys(this.$store.state.organization.current.dataAddress).length > 1 ? this.$store.state.organization.current.dataAddress : { country: 'NL', differentBillingAddress: false } // For some reason differentBillingAddress is already on this empty object
    this.dataBillingAddress = this.$store.state.organization.current.dataBillingAddress && Object.keys(this.$store.state.organization.current.dataBillingAddress).length ? this.$store.state.organization.current.dataBillingAddress : { country: 'NL' }
    this.dataAdministrationContact = this.$store.state.organization.current.dataAdministrationContact || {}
    this.dataSupportContact = this.$store.state.organization.current.dataSupportContact || {}
    this.defaultFormStyle = this.$store.state.organization.current.defaultFormStyle || { primaryColor: '#00b333', backgroundColor: '#E0E0E0' }

    delete this.dataGeneral._id // mongo adds these but we dont want to send them
    delete this.dataAddress._id
    delete this.dataBillingAddress._id
    delete this.dataAdministrationContact._id
    delete this.dataSupportContact._id
    delete this.defaultFormStyle._id

    if (this.$store.getters['organization/isFirstUse']) {
      this.$root.$swal({
        title: 'Welkom',
        html: `Voordat je gebruik kan maken van het platform, dien je eerst alle benodigde gegevens in te vullen.
<br>
<br>
Alle velden met een (*) zijn verplicht om in te vullen.`
      })
    }

    for (const key of ['dataGeneral', 'dataAddress', 'dataBillingAddress', 'dataAdministrationContact', 'dataSupportContact', 'defaultFormStyle']) {
      this.$watch(key, () => {
        this.$root.$save.show(this.save, null)
      }, { deep: true })
    }
    this.$watch('$v.$invalid', (v) => this.$root.$save.setValid(!v), { deep: true }) // Must be last

    setTimeout(() => {
      this.showFormStyle = true
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.text-field.small {
  max-width: 150px;
}
</style>
